import { createBrowserPlatform } from "./browser";
import type { Platform } from "./types";

export type { CadPick, Platform, RecentEntry, WorkSubmission } from "./types";
export { picksFromDataTransfer, defaultMasterPick } from "./browser";

let _platform: Platform | null = null;

/** Singleton platform for the browser SPA. */
export function getPlatform(): Platform {
  if (!_platform) {
    _platform = createBrowserPlatform();
  }
  return _platform;
}

/** Test helper */
export function __setPlatformForTests(p: Platform | null) {
  _platform = p;
}
